import React, {useState, useEffect , useCallback} from "react";
import styled from "@emotion/styled";
import { SearchFrame } from "./SearchFrame";
import { tokenize } from "../../front/search-query";
import withTranslator from "../Translator/withTranslation";
import additionalfn from "../../_additionalfn";
import colors from "../../../sass/brand_palette.scss";
import { compose } from "recompose";
import withFosRouter from "../FosRouter/withFosRouting";

const OptionCounter = styled.div`
    background-size: cover;
    width: 15px;
    height: 15px;
    background-color: ${colors.blue1};
    border-radius:100%;
    color:#fff;
    line-height: 1.4em;
    width: 1.5em;
    height: 1.4em;
`;

const CloseButton = styled.button`
  font-size: 2em;
`;

const MoreOptions = styled.button`
  font-size: 0.9em!important;
  line-height: 1.4em;
  font-weight: 600!important;
  @media (max-width: 576px) { 
    font-size: 1em!important;
  }
`;
const ClearFilter = styled.button`
  font-size: 0.9em!important;
  line-height: 1.4em;
  font-weight: 600!important;
  @media (max-width: 576px) { 
    font-size: 1em!important;
  }
`;

const MoreFieldsContainer = styled.div`
    position: absolute;
    margin-left: -1px;
    margin-right: -1px;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-right: 1px solid;
@media (max-width: 1400px) {
    font-size:0.85rem;
  }
  @media (max-width: 1200px) {
    font-size:1rem;
  }
  @media (max-width: 1023px) {
    position: absolute;
    margin-left: -1px;
    margin-right: -1px;
    border-bottom: 1px solid;
    border-left: 1px solid;
    border-right: 1px solid;
  }
  @media (max-width: 576px) {
    position: fixed;
  }
`;
const SearchFormWhiteComponent = (props) => {
  const [animation, setAnimation] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [queryString, setQueryString] = useState(props.queryString);
  const [open, setOpen] = useState(false);
  const [openButtonLabel, setOpenButtonLabel] = useState( (props.mobile || tablet) ? "moreoptions" : "moreoptions");
  const [openButtonIcon, setOpenButtonIcon] = useState("down");
  const [page, setPage] = useState(props.page);
  const [mobile, setMobile] = useState(props.mobile);
  const [tablet, setTablet] = useState(props.mobile);
  const [queryObject, setQueryObject] = useState(tokenize(props.queryString));
  const poolWithPrivacyEnabled = false;

  useEffect(() => {
    if (props.extendSearchOpenCallback && open) {
      additionalfn[props.extendSearchOpenCallback]();
    }

    if (props.extendSearchClosedCallback && !open) {
      additionalfn[props.extendSearchClosedCallback]();
    }
    setOpenButtonLabel( open ? "close"
      : mobile || tablet
      ? "moreoptions"
      : "moreoptions");

    setOpenButtonIcon(open ? "up" : "down");
  }, [open]);


  const handleSqueezelySearch = (e) => {
    setQueryString(e.detail.queryString);
    setQueryObject(tokenize(e.detail.queryString));
    onChange(e.detail);
    var updateEvent = new CustomEvent('SearchResults_changeQuery', { detail: { items: tokenize(e.detail.queryString) }});
    document.dispatchEvent(updateEvent);
    additionalfn.updateURL({r: props.r, query: e.detail.queryString});
  }

  useEffect(() => {
    document.addEventListener("squeezelySearch", handleSqueezelySearch);
    return () =>  { document.removeEventListener("squeezelySearch",handleSqueezelySearch);}
  }, []);

  const handleSearchFrameSubmit = (e) => {
    const timeout = setTimeout(() => {
      if (open) {
        extend();
      }}, 500);
      return () => clearTimeout(timeout);
  }

  useEffect(() => {
      const timeout = setTimeout(() => {
        if (isAnimating) {
          setIsAnimating(false);
        }
      }, 1000);
        
      return () => clearTimeout(timeout);
  }, [open, isAnimating])

  useEffect(() => {
    document.addEventListener("SearchFrame_submit", handleSearchFrameSubmit);
    return () =>  { document.removeEventListener("SearchFrame_submit",handleSearchFrameSubmit);}
  }, [open, setOpen]);
  
  const moreOptionsCount = useCallback(() => {
    if (!queryString || queryString.length == 0) return;

    var count = 0,
        moreOptions = [
  //        "region",
          "city",
          "distanceBeach",
          "poolType",
          "numBedrooms",
          "numBathrooms",
          "accommodationType",
          "youngstersAllowed",
          "internet",
          "airConditioning",
          "dishwasher",
          "washingMachine",
          "petsAllowed",
          "priceRange",
          "poolWithPrivacy",
          "seaView",
        ];

    for (var i in queryObject) {
      if (moreOptions.includes(i)) count++;
    }

    return count > 0 ? (
      <OptionCounter
        searchURLBase={props.searchURLBase}
        className="ml-1 font-80 white"
      >
        {count}
      </OptionCounter>
    ) : (
      ""
    );
  });

  const onChange = useCallback((data) => {
    setQueryString(data.queryString);
    setQueryObject(tokenize(data.queryString));
    props.onChange(data);
  });

  const onPageChange = useCallback((page) => {
    setPage(page);
    props.onPageChange(page);
  });

  const extend = () => {
    if (!open) {
      setIsAnimating(true);
    }
    setOpen(!open);
  };

  const renderForm = (fields) =>  {
    return (
      <div className={"width-inherit width-100 bg-white border-radius-default p-3 bor-thin bor-blue1 bor-solid" + (!mobile ? " bor-tl-rad-no " : "")} style={{top: '-1px'}}>
        {fields.modal}
        <div
          className={
            "row m-0 width-100 " +
            (!mobile ? "bg-white" : "")
          }
        >
          <div
            className={
              "col-xl-4 col-md-12 col-sm-12 px-0 pb-sm-2 " +
              (mobile ? "mb-2 px-0" : "") 
            }
          >
            {fields.region}
          </div> 
          <div
            className={
              "col-xl-4 col-md-6 col-sm-6 pl-xl-2 pl-md-0 pr-xl-0 pr-md-0 px-sm-0 pr-sm-0 mb-sm-0 mb-2  " +
              (mobile ? "px-0" : "")
            }
          >
            {fields.dates}
          </div>
          <div
            className={
              "col-xl-2 col-md-6 col-sm-12 px-sm-0 px-xl-0 mb-md-2 mb-sm-0 mb-2 " +
              (mobile ? "px-0" : "")
            }
          >
            {fields.maxSleeps}
          </div>
          <div
            className={
              "col-xl-2 col-md-12 col-sm-12 pl-xl-2 pr-xl-0 pl-md-0 pr-md-0 " +
              (mobile ? "px-0" : "")
            }
          >
            {fields.submit}
          </div>
        </div>
        <div className={"flex justify-sbetween bg-white pt-3 " + (mobile ? "px-sm-1 font-80 " : "")}>
          <div className="col-xl-2 col-md-4 p-0">
              <MoreOptions
                onClick={extend}
                type="button"
                className={
                  "btn btn-blue2 white flex justify-sbetween mb-0 btn-block mt-sm-2 mt-0 uppercase px-xl-2 py-xl-2 " 
                }
              >
                <div className="flex items-center align-sbetween">
                  <div className="width-100">{t(openButtonLabel)} {!mobile ? (
                    <img
                      src={
                        (props.searchURLBase
                          ? props.searchURLBase
                          : "") +
                        "/assets/img/front/icons/arrow-" +
                        openButtonIcon +
                        "-white.svg"
                      }
                      width="12"
                      height="auto"
                      alt="arrow"
                      className="ml-2"
                    />
                    ) : (
                      ""
                    )}
                  </div>
                  {moreOptionsCount()}
                </div>
              </MoreOptions>
          </div>
          <div className="col-xl-2 col-md-4 p-0">
              <ClearFilter
                onClick={fields.reset}
                type="button"
                className={
                  "btn btn-default blue1 bg-white bor-no text-right width-100  flex mt-sm-2 mb-0 mt-0 uppercase px-2 py-xl-2"
                }
                isOpen = { open }
              >
                <div className="width-100 flex items-center justify-fend"><img className="mr-2" src="/assets/img/front/icons/trash-48x48.png" height="16" width="16" />{t("clear_filter")}</div>
              </ClearFilter>
          </div>
        </div>
        <MoreFieldsContainer
            className={
              "row py-sm-2 pt-2 pb-6 z-index-1 opacity-0 " +
              (mobile
                ? "fixed top-0 left-0 height-100vh overflow-scroll-y"
                : "border-radius-default bor-tl-rad-no bor-tr-rad-no")
              + " bg-white blue1"
              + (!mobile && (isAnimating || !open) ? " overflow-y-hidden" : "")
            }
            style={{
              transition: isAnimating || !open ? "opacity 0.3s linear 0s" : "none",
              opacity: isAnimating || open ? 1 : 0,
              left: mobile ? ( open ? "0px" : "-9999px") : "0px",
            }}
          >
            <div
              className="px-3"
              style={{
                transition: open ? "margin 0.7s" : "none",
                marginTop: open ? 0 : "-135px",
              }}
            >
              <div className="row">
                {mobile ? (
                  <div className="col-12 text-right">
                    <CloseButton
                      type="button"
                      onClick={extend}
                      className={"btn-no bg-no bor-no mr-3 pad-no" + (mobile ? " blue1 " : " white")}
                    >
                      &times;
                    </CloseButton>
                  </div>
                ) : (
                  ""
                )}
                {!mobile ? (
                  <div className="col-12 bg-white blue1 bor-dashed bor-t-thin bor-blue1">
                  </div>
                ): ""
                }
                {props.priceRangeSettings ? (
                  <div className="col-12 pt-2  bg-white blue1 px-md-0">
                    <div className={"mx-3 mx-md-0 mx-xl-0 pt-0 pt-md-2 pt-xl-2 " + (mobile ? "bor-thin bor-solid bor-blue1 border-radius-default" : "")}>{fields.priceRange}</div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-xl-7 col-md-12 py-2 bg-white blue1">
                  <div className="flex flex-wrap">
                    <div className={"mb-0 mb-xl-2 mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.poolType}
                      </div>
                    </div>
                    <div className={"mb-0 mb-xl-2 mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.numBathrooms}
                      </div>
                    </div>
                    <div className={"mb-0 mb-xl-2  mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.accommodationType}
                      </div>
                    </div>
                    <div className={"mb-0 mb-xl-2 mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.numBedrooms}
                      </div>
                    </div>
                    <div className={"mb-0 mb-xl-2 mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.distanceBeach}
                      </div>
                    </div>

                    <div className={"mb-0 mb-xl-2  mb-md-2 col-sm-4 col-md-6 col-xl-4 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.city}
                      </div>
                    </div>
                    <div className={"mb-0 mb-xl-2  mb-md-2 col-sm-4 col-md-6 col-xl-8 px-1"}>
                      <div className="px-3 px-sm-0 py-2 py-sm-0 border-radius-default">
                        {fields.villaname}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-md-12 py-2 bg-white blue1">
                  <div className="row">
                    <div className="col-xl-6 col-md-6 mx-3 mx-sm-0 col-sm-4 pl-sm-2 mb-3 mb-xl-0">
                      <ul className="pl-sm-2 flex flex-column " style={{gap:'1rem'}}>
                        <li>{fields.airConditioning}</li>
                        <li>{fields.petsAllowed}</li>
                        <li>{fields.seaView}</li>
                        <li className="mb-2">
                          {fields.youngstersAllowed}
                        </li>
                      </ul>
                    </div>
                    <div className="col-xl-6 col-md-6 col-sm-4 mx-3 mx-sm-0 pl-sm-2">
                      <ul className="pl-sm-2 flex flex-column " style={{gap:'1rem'}}>
                        <li className="mb-2">{fields.internet}</li>
                        <li className="mb-2">{fields.dishwasher}</li>
                        <li className="mb-2">{fields.washingMachine}</li>
                        {poolWithPrivacyEnabled && <li>{fields.poolWithPrivacy}</li> }
                      </ul>
                    </div>
                  </div>
                </div>
                {mobile ? (
                  <div
                    className="col-12 text-center"
                    onClick={extend}
                  >
                    <div className="fixed left-0 bottom-0 width-100">
                      {fields.submit}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </MoreFieldsContainer>
      </div>
      )
  };

  const  t = props.t;

  return (
      <div
        className={
          mobile ? "container-fluid" : "relative width-100 px-3"
        }
      >
        {!mobile ? (
          <div className="row m-0 bg-white blue1 font-w600 px-3 pt-2 font-90 inline-block border-radius-default-t bor-t-thin bor-l-thin bor-r-thin bor-solid z-index-2">
            {t("searchourvillas")}:
          </div>
        ) : (
          ""
        )}
        <SearchFrame
          locale={props.locale}
          initial_query={props.initial_query}
          currency={props.currency}
          onChange={data => onChange(data)}
          onPageChange={page => onPageChange(page)}
          slideshowImages={
            props.slideshowImages ? props.slideshowImages : 5
          }
          arrivalOffset={props.arrivalOffset}
          perpage={props.perpage ? props.perpage : 12}
          queryString={queryString}
          queryResult={props.queryResult}
          mobile={mobile}
          maxSleepsType={props.maxSleepsType}
          updateURL={props.updateURL}
          hideResults={props.hideResults}
          priceRangeSettings={props.priceRangeSettings}
          defaultQuery={props.defaultQuery}
          page={page}
          searchFieldsOnly={props.searchFieldsOnly}
          searchURLBase={props.searchURLBase}
          open={open}
          poolWithPrivacyEnabled={poolWithPrivacyEnabled}
          renderForm={renderForm}
          searchFormVariant="white"
        />
      </div>
  );
}

export const SearchFormWhite = compose(
  withTranslator,
  withFosRouter
)(SearchFormWhiteComponent);
